import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import cx from 'classnames';
import styles from '../forms.module.scss';

export default function FormPreview(props) {
  const handleClose = () => {
    document.body.click();
    props.onClose()
  }

  const renderFormPreview = (form) => {
    switch (form.type) {
      case "hubspot":
        return <HubspotFormPreview editable={props.editable} previewName={"previewModal"} form={form} smallCardView={false} />

      case "marketo":
        return <MarketoFormPreview editable={props.editable} form={form} smallCardView={false} onFormSubmit={() => props.onFormSubmit()} />

      case "pardot":
        return <PardotFormPreview editable={props.editable} form={form} smallCardView={false} onFormSubmit={() => props.onFormSubmit()} />

      case "external": 
        return <ExternalFormPreview editable={false} url={_.get(form, 'configuration.url', '')} />
    }
  }

  return (
    <Modal show={props.preview} className={cx(styles.confirmation, styles.dialog)} backdropClassName={styles.overlay} centered>
      <Modal.Header>
        <div className={styles.closeButton}>
          <i className={cx("cleverstory-close")} onClick={handleClose} />
        </div>
      </Modal.Header>
      <Modal.Body className={cx(styles.body, { [styles.pardotFormBody]: (props.form.type === "pardot") })}>
        {renderFormPreview(props.form)}
      </Modal.Body>
    </Modal>
  )
}

export function HubspotFormPreview({ form, editable, previewName, smallCardView }) {
  const region = _.get(form, 'configuration.region', "na1");
  const portalId = _.get(form, 'configuration.portalId', null);
  const guid = _.get(form, 'configuration.guid', null);


  useEffect(() => {
    if (window.hbspt && guid) {
      window.hbspt.forms.create({
        region: region || "na1",
        portalId: portalId,
        formId: guid,
        target: `#${previewName}_${form.id}`,
      });
    }
  }, [])

  return (
    <div className={cx({ [styles.disbaleModel]: !editable }, { [styles.smallCardView]: smallCardView })} id={`${previewName}_${form.id}`}></div>
  )
}

export const MarketoFormPreview = ({ form, editable, previewName, onFormSubmit, smallCardView }) => {
  const formContainerRef = React.useRef(null);

  const [state, setState] = useState({
    loading: false,
    scriptLoaded: false,
    formloaded: false
  });

  var formId = _.get(form.configuration, 'formId', null);
  var munchkinId = _.get(form.configuration, 'munchkinId', null);
  var domain = _.get(form.configuration, 'domain', null);

  const appendScript = (baseUrl) => {
    if (window.MktoForms2) {
      return;
    }

    const script = document.createElement("script");
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
    script.onload = () => {
      loadForm();
    }

    document.body.appendChild(script);
  }

  useEffect(() => {
    if (!window.MktoForms2) {
      appendScript(domain);
    } else {
      loadForm();
    }
  }, [form.configuration]);

  const loadForm = () => {
    if (!window.MktoForms2) {
      return;
    }

    window.MktoForms2.whenReady(function (form) {

      setState((state) => {
        return {
          ...state,
          loading: false,
        }
      })
    });

    const loadedForm = window.MktoForms2.getForm(formId);
    if (loadedForm) {
      destroyForm();
      renderForm(loadedForm);
    } else {
      window.MktoForms2.loadForm(domain, munchkinId, formId, function (form) {
        destroyForm();
        renderForm(form);
      });
    }
  }


  const renderForm = (form) => {
    if (!form) {
      return;
    }
    const formElement = document.createElement("form");

    const rendered = form.render(formElement);

    if (_.size(rendered) == 0) {
      return;
    }

    rendered[0].setAttribute("id", "marketo_" + new Date().getTime());
    formContainerRef.current.appendChild(rendered[0]);

    form.onSubmit(function (e) {
      if (onFormSubmit) {
        onFormSubmit();
      }
    });

    form.onSuccess(function (values, followUpUrl) {
      return false;
    });
  }

  const destroyForm = () => {
    formContainerRef.current.innerHTML = "";
  }

  if (!form) {
    return null;
  }

  return (
    <div key={formId} className={cx(styles.marketoFormContainer, { [styles.smallCardMarketoView]: smallCardView }, { [styles.disbaleModel]: !editable }, { [styles.loadingMarketoForm]: state.loading })}>
      {state.loading && <div>Loading Marketo Form.... </div>}
      <div ref={formContainerRef}></div>
    </div>
  )
}

export function PardotFormPreview({ form, editable, smallCardView, onFormSubmit }) {
  let embedCode = _.get(form, "configuration.embedCode", "");

  const handleFormSubmit = (e) => {
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type === 'PARDOT_FORM_SUBMISSION') {
      if (onFormSubmit) {
        onFormSubmit();
      }
    }

    deEventer(messageEvent, handleFormSubmit, false);
  }

  useEffect(() => {
    //Attaching message event listner
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, handleFormSubmit, false);
  }, [])

  return (
    <div className={cx({ [styles.disbaleModel]: !editable }, { [styles.smallCardView]: smallCardView }, styles.pardotFormRenderer)} onClick={(e) => e.preventDefault()} dangerouslySetInnerHTML={{ __html: embedCode }}></div>
  )
}

export function ExternalFormPreview({ url, editable, smallCardView}) {
  return (
    <div className={cx({ [styles.disbaleModel]: !editable }, { [styles.smallCardView]: smallCardView }, styles.externalformRender)}>
      <iframe width='100%' height='579px' src={url} />
    </div>
  )
}
